<template>
  <div class="content_main">
    <p class="content_normal">Flypay is a financial technology company. Our company has reached out
      to a lot of loan seekers online and has helped them sort out their financial challenges with
      Zero stress. Our loan does not require physical collateral and is targeted at business owners
      who can get a return within a short period of time and repay.</p>
    <br />
    <p class="content_normal">You are receiving this notice because of your overdue loan that is yet
      to be repaid. A few times our agent has tried to reach you and negotiate the current situation
      but there has not been a resolution. After this notification and if we are unable to get a
      proper response from you, we will enter a pre-litigation stage where our legal practitioners
      will take up the affairs of your loan.</p>
    <br />
    <p class="content_normal">If you are finding it difficult to repay, our company can waive the
      late payment fee of 20% and lets you repay the remaining outstanding. Kindly respond to our
      recovery officers or contact: </p>
    <br />
    <p class="content_normal">WhatsApp-09120482700</p>
    <p class="content_normal">Email- collection@flypay.ng</p>
    <br />
    <p class="content_normal">This letter requires you to give an immediate response.</p>
    <br />
    <p class="content_normal">While waiting for your prompt reply, do have the assurance our best
      regards.</p>

  </div>
</template>

<script>
export default {
  name: 'flypayM1',
};
</script>


<style lang="stylus" scoped>
px = (1 / 24.75vw);
.content {
  padding: 25 *px 16 *px;

  .content_main {
    line-height: 20px;
    text-indent: 16px;
    margin-top: 16px;
  }

  .content_normal {
    text-align: left;
    text-indent: 16px;
  }
}
</style>
